import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs'; 
//import { SharedModule } from '../../shared/shared.module';

import { SendAccrualToIntacctComponent} from '../send-accrual-general-journal-to-intacct/send-accrual-to-intacct.component'

@NgModule({
  declarations: [SendAccrualToIntacctComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule,
    GridModule,
    DateInputsModule
    // SharedModule,
  ],
  exports: [SendAccrualToIntacctComponent],
  providers: [],
})
export class SendAccrualToIntacctModule { }